<template>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-expansion-panels v-model="panel" multiple>
      <!--////////////////////////////////////////////// Identificación ////////////////////////////////////////////////////////////-->
      <!--Matricula Inmobiliaria / Placa / Serial-->
      <v-col cols="12" sm="12" md="12">
        <v-text-field
          v-model="editedItem.Ref1"
          label="Matrícula Inmobiliaria / Placa / Serial :"
          hint="Digite Información"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :clearable="clearcampos.Ref1"
          :readonly="readcampos.Ref1"
        >
        </v-text-field>
      </v-col>
      <!--////////////////////////////////////////////// Caracteristicas inmuebles (solo para inmuebles) ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-home-alert </v-icon>
            Características Inmuebles
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Fecha Avalúo Catastral-->
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.FechaAvaluoComercial"
                label="Fecha Avalúo Catastral:"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Avaluo Catastral-->
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.FechaAvaluoCatastral"
                label="Fecha Avaluo Catastral:"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Moneda -->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.CodMoneda"
                :items="ArrayDesMoneda"
                :item-title="
                  (ArrayDesMoneda) =>
                    ArrayDesMoneda.CodMonedaId +
                    '-' +
                    ArrayDesMoneda.Sigla +
                    '-' +
                    ArrayDesMoneda.Descripcion
                "
                item-value="CodMonedaId"
                color="primary"
                label="Moneda :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Valor Avaluo Comercial -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.ValorAvaluoComercial"
                label="Valor Avaluo Comercial:"
                type="number"
                step="0.01"
                hint="Digite Información"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
                maxlength="15"
                counter="15"
              >
              </v-text-field>
            </v-col>
            <!--Valor Avaluo Catastral -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.ValorAvaluoCatastral"
                label="Valor Avaluo Catastral:"
                type="number"
                step="0.01"
                hint="Digite Información"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
                maxlength="15"
                counter="15"
              >
              </v-text-field>
            </v-col>
            <!--Area Terreno -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.AreaTerreno"
                label="Area Terreno:"
                type="number"
                step="0.01"
                hint="Digite Información"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
                maxlength="15"
                counter="15"
              >
              </v-text-field>
            </v-col>
            <!--Area Construcción -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.AreaConstruida"
                label="Area Construcción:"
                type="number"
                step="0.01"
                hint="Digite Información"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                dense
                clearable
                maxlength="15"
                counter="15"
              >
              </v-text-field>
            </v-col>
            <!--Frente Inmueble -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.FrenteInmueble"
                label="Frente Inmueble:"
                type="number"
                step="0.01"
                hint="Digite Información"
                dense
                clearable
                maxlength="10"
                counter="10"
              >
              </v-text-field>
            </v-col>
            <!--Licencia de Construcción-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.LicenciaUrbanCons"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Licencia de Construcción:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Clasificación del Suelo-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.ClasificacionSuelo"
                :items="
                  ArrayClasificacion.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor),
                  }))
                "
                :item-title="
                  (ArrayClasificacion) =>
                    ArrayClasificacion.Valor +
                    '-' +
                    ArrayClasificacion.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Clasificación del Suelo:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>

            <!--Tratamiento del Suelo-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.TratamientoSuelo"
                label="Tratamiento del Suelo:"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="10"
                counter="10"
              >
              </v-text-field>
            </v-col>
            <!-- Gestor Catastral -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.GestorCatastral"
                label="Gestor Catastral:"
                hint="Digite Información"
                dense
                clearable
                maxlength="100"
                counter="100"
              >
              </v-text-field>
            </v-col>
            <!--Afectaciones-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.Afectaciones"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Afectaciones:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Validado-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.Validado"
                :items="
                  ArrayValidado.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayValidado) =>
                    ArrayValidado.Valor + '-' + ArrayValidado.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Avalúo Validado:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha Próximo Avaluo-->
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="editedItem.FechaProximoAvaluo"
                label="Fecha Próximo Avaluo:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!-- Observaciones -->
            <v-col cols="12" sm="6" md="12">
              <v-textarea
                v-model="editedItem.Observaciones"
                name="input-7-1"
                filled
                label="Observaciones adicionales:"
                auto-grow
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "avaluos_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    llavesiframe: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      panel: [0],
      progreso: false,
      buttonSave: false,
      editedItem: {
        AvaluoID: null,
        Ref1: null,
        FechaAvaluoComercial: null,
        FechaAvaluoCatastral: null,
        CodMoneda: null,
        ValorAvaluoCatastral: null,
        ValorAvaluoCatastral: null,
        AreaTerreno: null,
        AreaConstruida: null,
        FechaProximoAvaluo: null,
        Observaciones: null,
        FrenteInmueble: null,
        LicenciaUrbanCons: null,
        ClasificacionSuelo: null,
        TratamientoSuelo: null,
        GestorCatastral: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        Afectaciones: null,
        Validado: null,
      },
      defaultItem: {
        AvaluoID: null,
        Ref1: null,
        FechaAvaluoComercial: null,
        FechaAvaluoCatastral: null,
        CodMoneda: null,
        ValorAvaluoCatastral: null,
        ValorAvaluoCatastral: null,
        AreaTerreno: null,
        AreaConstruida: null,
        FechaProximoAvaluo: null,
        Observaciones: null,
        FrenteInmueble: null,
        LicenciaUrbanCons: null,
        ClasificacionSuelo: null,
        TratamientoSuelo: null,
        GestorCatastral: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        Afectaciones: null,
        Validado: null,
      },
      clearcampos: {
        Ref1: true,
      },
      readcampos: {
        Ref1: false,
      },
      ArrayClasificacion: [],
      ArrayDesMoneda: [],
      ArraySiNo: [],
      ArrayValidado: [],
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        // Todos
        this.editedItem.Ref1 == "" ||
        this.editedItem.Ref1 == null ||
        this.editedItem.FechaAvaluoComercial == "" ||
        this.editedItem.FechaAvaluoComercial == null ||
        this.editedItem.FechaAvaluoCatastral == "" ||
        this.editedItem.FechaAvaluoCatastral == null ||
        this.editedItem.ValorAvaluoComercial == "" ||
        this.editedItem.ValorAvaluoComercial == null ||
        this.editedItem.ValorAvaluoCatastral == "" ||
        this.editedItem.ValorAvaluoCatastral == null ||
        this.editedItem.AreaTerreno == "" ||
        this.editedItem.AreaTerreno == null ||
        this.editedItem.AreaConstruida == "" ||
        this.editedItem.AreaConstruida == null
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/ActivosO/Avaluos/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      this.axios
        .put("/ActivosO/Avaluos/UP0", this.editedItem)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    // Cargue Combos
    CargueCombos() {
      this.ArrayClasificacion = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 66
      );

      // Array Moneda
      var Moneda = this.$store.getters.MDescMoneda;
      this.ArrayDesMoneda = Moneda.filter((item) => item.CodMonedaID != 0);

      // Array si o no
      this.ArraySiNo = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 16
      );

      // Array Validado
      this.ArrayValidado = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 68
      );
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        this.clearcampos.Ref1 = false;
        this.readcampos.Ref1 = true;
      } else {
        console.log(this.llavesiframe);
        this.editedItem.Ref1 = this.llavesiframe.Ref_1;
        this.clearcampos.Ref1 = false;
        this.readcampos.Ref1 = true;
      }
    },
    ///////////////////////////////////////////////// Cambios de campos ///////////////////////////////////////////
    // Item editar
    editItem(item) {
      var data = true;
      this.$emit("update:componenteview", item.iconoelegido);
      this.$emit("update:iconodialogbtn", item.icono);
      this.$emit("update:titledialogbtn", item.descripcion);
      this.$emit("update:pageiframe", data);
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
